import type { SurveyAnswerRecord, SurveyConfig } from '../types'

/**
 * 未回答の質問を除外したアンケート設定を生成する
 */
export function filterSurveyConfigByAnsweredQuestions(
  surveyConfig: SurveyConfig | null,
  surveyAnswer: SurveyAnswerRecord | null,
): SurveyConfig | null {
  if (!surveyConfig || !surveyAnswer) {
    return surveyConfig
  }

  // 回答されている質問IDsを取得
  const answeredQuestionIds = Object.keys(surveyAnswer)

  // 回答済み質問のみを含むようにelementsをフィルタリング
  if (surveyConfig.elements) {
    return {
      ...surveyConfig,
      elements: surveyConfig.elements.filter(element =>
        answeredQuestionIds.includes(element.name),
      ),
    }
  }

  return surveyConfig
}
